import { Grid, Typography } from '@mui/material'
import { Box } from '@mui/system'
import React from 'react'
// import { useDispatch } from 'react-redux'
// import { getAllUsersOfSuborganizations } from '../../../../../redux/actions/Suborganizations'

// import { namesTypesTraduc } from '../../../../../utils/traducTypes'

import useStyleSeeMore from './useStyleSeeMore'
import CloseIcon from '@mui/icons-material/Close'
import {
  commercialTypesTraduc,
  namesTypesTraduc,
  traducUserStatus
} from '../../../../utils/traducTypes'

export const UserSeeMore = ({
  item,
  setLoading,
  setstateSeeMore,
  userRol,
  userInstance
}) => {
  const classes = useStyleSeeMore()

  // traduc types in spanish
  const traducSpanishTypes = (type) => {
    const nameTraduc = namesTypesTraduc.filter((item) => item.code === type)
    return nameTraduc.length > 0 ? nameTraduc[0].name : null
  }

  // traduct commercial types in spanish
  const traducSpanishCommercialTypes = (type) => {
    const nameTraduc = commercialTypesTraduc.filter(
      (item) => item.code === type
    )
    return nameTraduc.length > 0 ? nameTraduc[0].name : null
  }

  const getNameUser = () => {
    return item.account?.firstName + ' ' + item.account?.lastName
  }

  const formatDate = (date) => {
    let formattedDate
    if (date) {
      const newDate = new Date(date)
      formattedDate =
        newDate.getDate() +
        '/' +
        (newDate.getMonth() + 1) +
        '/' +
        newDate.getFullYear()
    } else {
      formattedDate = ''
    }
    return formattedDate
  }


  const DetailsUser = ({ item }) => {
    return (
      item && (
        <>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.key}>
                Nombre y apellido:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.value}>{getNameUser()}</Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.key}>Email:</Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.value}>
                {item.account.email}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.key}>
                Acceso a Mi Estudio:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.value}>
                {userInstance.userAppAccessStatusCode === 'GRANTED'
                  ? 'Habilitado'
                  : 'No habilitado'}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.key}>Rol asignado:</Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.value}>
                {userRol.appRoleName}
              </Typography>
            </Grid>
          </Grid>

          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.key}>Habilitado desde:</Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.value}>
                {formatDate(userInstance.accessStartDate) ||
                  'Fecha no definida'}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.key}>Habilitado hasta:</Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.value}>
                {formatDate(userInstance.accessFinishtDate) ||
                  'Fecha no definida'}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.key}>
                Tipo de usuario organización:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.value}>
                {traducSpanishTypes(item.type?.organizationUserTypeCode) ||
                  '- -'}
              </Typography>
            </Grid>
          </Grid>

          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.key}>
                Tipo comercial del usuario organización:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.value}>
                {traducSpanishCommercialTypes(
                  item.commercialType?.organizationCommercialUserTypeCode
                ) || '- -'}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.key}>
                Estado de usuario organización:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.value}>
                {traducUserStatus(item.status?.userStatusCode) || '- -'}
              </Typography>
            </Grid>
          </Grid>
        </>
      )
    )
  }

  return (
    <>
      <Box className={classes.backgroundBox}>
        <div
          style={{
            width: '100%',
            display: 'flex',
            padding: '8px 0px 8px 0px',
            justifyContent: 'space-between',
            boxShadow: '0px 1px 1px #EAEAEA',
            color: '#8C8C8C'
          }}
        >
          <Typography className={classes.seeMoreTypography}>
            Información del usuario
          </Typography>
          <CloseIcon
            style={{
              cursor: 'pointer',
              paddingRight: 10,
              fontSize: '1.5rem'
            }}
            onClick={() => {
              setstateSeeMore(false)
            }}
          />
        </div>
        <div className={classes.mainBox}>
          <DetailsUser item={item} />
        </div>

        <ButtonClose setstateSeeMore={setstateSeeMore} />
      </Box>
    </>
  )
}

function ButtonClose ({ setstateSeeMore }) {
  const classes = useStyleSeeMore()
  return (
    <Box className={classes.closeButton}>
      <Box
        className={classes.closeButtonStyle}
        sx={{
          '&:hover': {
            bgcolor: '#1BF57F'
          }
        }}
      >
        <Typography
          onClick={() => {
            setstateSeeMore(false)
          }}
          className={classes.closeButtonTypography}
        >
          Cerrar
        </Typography>
      </Box>
    </Box>
  )
}
